export const tutassurHeader = `<style>
  .tth *{box-sizing:border-box;margin:0;padding:0}
  .tth{background:#000;font-family:system-ui,sans-serif;display:flex;align-items:center;justify-content:center;padding:16px 24px;height:72px}
  .tth-logo img{height:40px;width:auto;object-fit:contain;filter:brightness(0) invert(1)}
</style>
<div class="tth">
  <div class="tth-logo">
    <img src="/tutassur-logo.png" alt="Tutassûr" />
  </div>
</div>`;
